import React from 'react'

const ConcertsScreen = () => {
  return (
    <div>ConcertsScreen</div>
  )
}

export default ConcertsScreen